

exports.__esModule = true;

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _logger = require('xo-beaver/dist/logger');

var _auth = require('xo-models/src/auth');

var _model = require('xo-tracking/dist/model');

var _index = require('xo-device-info/dist/index');

var _index2 = require('xo-models/src/credit/index');

var _squid = require('squid');

var _index3 = require('xo-models/src/checkout/index');

var _uiRouter = require('uiRouter');

var _xoCreditBannerUtils = require('../lib/xo-credit-banner-utils');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

var _constants = require('../xo-credit-offer-banners/de-banner/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Consider all available query params for
 * base return url
 *
 * @param {*} url
 * @param {*} token
 * @returns
 */
var getReturnUrl = function getReturnUrl(url, token) {
    var params = _squid.$util.params();
    params = _squid.$util.extend(params, { token: token });
    return _squid.$util.buildURL(url, params);
};

/**
 * Include redirect_uri logic for cancel url
 *
 * @param {*} url
 * @param {*} token
 * @returns
 */
var getCancelUrl = function getCancelUrl(url, token) {
    var redirectUri = _squid.$util.param('redirect_uri');

    // "redirect_uri" as a query param overrides the cancel url in the checkout session
    if (_squid.$integration.getConfig('REDIRECT_QUERY_PARAM') && redirectUri) {

        return _squid.$util.buildURL(redirectUri, {
            opType: 'cancel',
            return_uri: url,
            token: token
        });
    }
    return url;
};

exports['default'] = _squid.$Component.extend('$xoRedirectToCapeDirective', {
    tag: 'xo-redirect-to-cape',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutAppData: _index3.$CheckoutAppDataModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                auth: _auth.$AuthModel.instance().retrieve()['catch'](_angular.noop),
                checkoutCart: _index3.$CheckoutCartModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                checkoutPayee: _index3.$CheckoutPayeeModel.instance(this.props.token).retrieve()['catch'](_angular.noop)
            };
        },
        experiments: function experiments(resolvers) {
            return resolvers.models.then(function (models) {
                var isOneTouchTreatment = function isOneTouchTreatment() {
                    if (models.auth.remembered) {
                        return (0, _squid.$elmo)('xo_us_ppc_onetouch', {
                            'ctx.COUNTRY': _squid.$locale.country
                        }, 'Trmt_xo_us_ppc_onetouch_.*', false, true).then(function (result) {
                            if (result && result.treatment_name) {
                                return result.treatment_name === 'Trmt_xo_us_ppc_onetouch_1';
                            } else {
                                return false;
                            }
                        });
                    }
                };

                return {
                    isOneTouchTreatment: isOneTouchTreatment()
                };
            });
        },
        checkoutLiteDeInstallmentsCheck: function checkoutLiteDeInstallmentsCheck(_ref) {
            var _this = this;

            var models = _ref.models;


            // Check if they came from Checkout Lite for DE installments.
            if (_squid.$locale.country !== 'DE' || !_squid.$util.param('fromLite')) {
                _logger.$logger.info('xolite_de_installments_check_not_DE_eligible');
                return;
            }
            return models.then(function (_ref2) {
                var auth = _ref2.auth,
                    checkoutCart = _ref2.checkoutCart,
                    checkoutPayee = _ref2.checkoutPayee,
                    checkoutAppData = _ref2.checkoutAppData;

                // This is a safety precaution. If not logged in, the checkout session call and the ssot call will probably not succeed.
                if (!auth.logged_in) {
                    _logger.$logger.info('xolite_de_installments_skip_no_auth');
                    return;
                }

                _logger.$logger.info('xolite_de_installments_check_running');
                var checkoutSession = _index3.$CheckoutSessionModel.instance(_this.props.token);
                return checkoutSession.retrieve().then(function () {
                    return _xoCreditBannerUtils.$xoCreditBannerUtils.callSsotAndMapBanner(_this.props.token, {
                        checkoutSession: checkoutSession,
                        checkoutCart: checkoutCart,
                        checkoutAppData: checkoutAppData,
                        payee: checkoutPayee
                    }, _constants.deContentKeys.acq).then(function (ad) {
                        if (ad) {
                            var financing_option_details = {
                                credit_type: ad.ssotType,
                                financing_code: ad.financingCode,
                                apr: ad.apr,
                                term: ad.term,
                                total_cost: ad.totalDue,
                                total_interest: ad.totalInterest,
                                monthly_payment: ad.monthlyPayment,
                                currency: ad.monthlyPaymentCurrencyCode,
                                nominal_rate: ad.nominalRate,
                                monthly_percentage_rate: ad.monthlyPercentageRate,
                                paypal_subsidy: ad.paypalSubsidy
                            };
                            _uiRouter.$stateParams.financing_option = financing_option_details;
                            return ad;
                        } else {
                            // what to do if ssot call fails?
                            return;
                        }
                    });
                });
            })['catch'](function (err) {
                _logger.$logger.warn('xolite_de_installments_check_failed', { error: err });
                return;
            });
        },


        // When falling back from Checkout Lite, the user may have seen an incentive offer, which is decided by MORS.
        // Incentives information needs to be passed along to CAPE through a mayfly payload, so here we call MORS if we detect that the user came from Checkout Lite.
        incentivesCheck: function incentivesCheck(_ref3) {
            var _this2 = this;

            var models = _ref3.models;

            var isSecondButtonFullPay = _squid.$util.param('fullPay') === 'true';
            var isSecondButtonPaylaterFromLite = _squid.$Class.get(window, 'xprops.originFundingSource') === 'paylater' && _squid.$util.param('fromLite');

            return models.then(function (_ref4) {
                var auth = _ref4.auth,
                    checkoutCart = _ref4.checkoutCart,
                    checkoutPayee = _ref4.checkoutPayee,
                    checkoutAppData = _ref4.checkoutAppData;

                // This is a safety precaution. If not logged in, the checkout session call and the MORS call will probably not succeed.
                if (!auth.logged_in) {
                    _logger.$logger.info('xolite_incentives_skip_no_auth');
                    return;
                }

                // Don't pass incentives if 2ndBtn and user did not cancel-back to RYI and user is not in GPL-2ndBtn/XO-Lite
                if (checkoutAppData.isSecondButton() && !isSecondButtonFullPay && !isSecondButtonPaylaterFromLite) {
                    _logger.$logger.info('xolite_incentives_skip_when_second_button_txn');
                    return;
                }

                _logger.$logger.info('xolite_incentives_check_running');

                // common method to retrieve incentive offer message details from MORS
                var xolite_incentives_check_mors_call_handler = function xolite_incentives_check_mors_call_handler(mors_models) {
                    return _xoCreditBannerUtils.$xoCreditBannerUtils.callDiscoverMessagesAndMapToBanner(_this2.props.token, mors_models).then(function (_ref5) {
                        var result = _ref5.banner;

                        _angular.$rootScope.MORS = {};
                        // Result is read from the MORS object on rootscope in the lifecycle.populate function of this directive.
                        _angular.$rootScope.MORS[result.cacheId] = result;
                        return result;
                    });
                };

                var checkoutSession = _index3.$CheckoutSessionModel.instance(_this2.props.token);
                return checkoutSession.retrieve().then(function () {
                    return xolite_incentives_check_mors_call_handler({
                        checkoutSession: checkoutSession,
                        payee: checkoutPayee,
                        checkoutCart: checkoutCart
                    });
                })['catch'](function (err) {
                    if (err && err.message === 'NEED_CREDIT_CARD') {
                        // as we are only interested in the data contained in the xo-session to build the MORS
                        // request, we can safely ignore the 'NEED_CREDIT_CARD' contingency error that is being
                        // returned when user has no valid credit-cards in wallet;
                        // we will retrieve the xo-session data from the model instance itself and we will continue
                        // retrieving the incentive offer message details from MORS
                        _logger.$logger.warn('xolite_incentives_check_override_caught_error');
                        return xolite_incentives_check_mors_call_handler({
                            checkoutSession: checkoutSession,
                            payee: checkoutPayee,
                            checkoutCart: checkoutCart
                        });
                    } else {
                        throw err;
                    }
                });
            })['catch'](function (err) {
                _logger.$logger.warn('xolite_incentives_check_failed', { error: err });
                return;
            });
        }
    },
    lifecycle: {
        populate: function populate() {
            var _this3 = this;

            // eslint-disable-line max-statements
            var navigation = window.performance && window.performance.navigation || {};
            if (navigation.type === 2) {
                _logger.$logger.info('CAPE_redirect_on_history_traversal');
            }

            var checkoutSession = _index3.$CheckoutSessionModel.instance(this.props.token);
            var isPPCReuse = _xoCreditBannerUtils.$xoCreditBannerUtils.isCreditInWallet(checkoutSession, this.models.checkoutCart.isBillingNoPurchase());
            var isOnetouchULRedirect = this.models.auth.isOnetouchULRedirect();

            _logger.$logger.info('redirectToCape', { isOneTouchTreatment: this.experiments.isOneTouchTreatment, isPPCReuse: isPPCReuse, isOnetouchULRedirect: isOnetouchULRedirect, isRemembered: this.models.auth.remembered, isLoggedIn: this.models.auth.logged_in });
            if (this.models.auth.remembered && (!isPPCReuse || isOnetouchULRedirect)) {
                _logger.$logger.info('redirectToCape: go checkout.login');
                return this.models.auth.redirectToLogin('insufficientPermission', { ulClientKey: 'payWithPayPalCredit' });
            }
            _logger.$logger.info('redirectToCape: continue to CAPE');

            function getMORSCreditIncentiveCampaign(MORSCampaigns) {
                var creditIncentiveCampaign = null;

                Object.keys(MORSCampaigns).forEach(function (key) {
                    // A "credit incentive" campaign is one that contains
                    // the "incentiveOfferProgramId" property
                    if (MORSCampaigns[key] && MORSCampaigns[key].hasOwnProperty('incentiveOfferProgramId')) {
                        creditIncentiveCampaign = MORSCampaigns[key];
                    }
                });
                return creditIncentiveCampaign;
            }

            function createAuditData(creditIncentiveCampaign) {
                // As per credit.CommonComponentsSpecification/v2/credit_incentive_offer_info.json
                // specification
                var messages = [{
                    'credit_incentive_offer_descriptor': 'PID-' + creditIncentiveCampaign.placementCode,
                    'credit_incentive_offer_value': creditIncentiveCampaign.buyItemId
                }];

                // If there is an incentiveOfferProgramCode that comes back from MORS,
                // add it to the list of messages
                // (In addition to the PID-<placementCode> item)

                if (creditIncentiveCampaign.incentiveOfferProgramCode) {
                    messages.push({
                        'credit_incentive_offer_descriptor': 'incentive_offer_program_code',
                        'credit_incentive_offer_value': creditIncentiveCampaign.incentiveOfferProgramCode
                    });
                }

                return {
                    'credit_incentive_offer_messages': messages
                };
            }

            function createCreditIncentiveContextData(creditIncentiveCampaign) {
                return {
                    incentive_offer_program_id: creditIncentiveCampaign.incentiveOfferProgramId,
                    incentive_offer_value: creditIncentiveCampaign.incentiveOfferValue,
                    incentive_offer_currency_code: creditIncentiveCampaign.incentiveOfferCurrencyCode,
                    headline_text: creditIncentiveCampaign.headlineText,
                    offer_text_1: creditIncentiveCampaign.bodyText,
                    offer_text_2: creditIncentiveCampaign.bodyText2,
                    terms_link: creditIncentiveCampaign.termsLink,
                    terms_link_text: creditIncentiveCampaign.termsLinkText,
                    terms_text: creditIncentiveCampaign.termsText,
                    buy_item_id: creditIncentiveCampaign.campaignId,
                    audit_data: createAuditData(creditIncentiveCampaign)
                };
            }
            this.creditDataModel = _index2.$CreditDataModel.instance(this.props.token || _angular.$rootScope.token);
            var url = 'https://' + window.location.host + _squid.$config.urls.baseUrl;
            var returnUrl = getReturnUrl(url, this.props.token);
            var transactionType = this.models.checkoutAppData.is_second_button_txn ? 'SECOND_BUTTON' : 'HERMES';
            var isSignupFlow = this.models.auth.logged_in ? 'false' : 'true';
            var isRP = this.models.checkoutCart.get('billing.type') === 'RECURRING_PAYMENTS';
            var trafficSourceContent = '';
            var pageContext = 'Full-context';
            var flow = this.models.checkoutAppData.is_second_button_txn ? 'CHECKOUT_CREDIT_BUTTON' : 'CHECKOUT';
            this.buyerCountry = _squid.$locale.country.toUpperCase();
            this.currencyCode = this.models.checkoutCart.getCartCurrencyCode();
            var fundingInstruments = checkoutSession.fundingOptions && checkoutSession.fundingOptions.instruments;
            var fundingSource = fundingInstruments && _squid.$util.find(fundingInstruments, function (fi) {
                return fi.name === 'BILL_ME_LATER';
            });
            if (_angular.$rootScope.miniBrowser) {
                pageContext = 'Mb-context';
            } else if (_angular.$rootScope.isIFrame) {
                pageContext = 'In-context';
            }

            if (this.models.checkoutCart.isBillingNoPurchase()) {
                if (isRP) {
                    trafficSourceContent = 'BA_RP_WITHOUT_PURCHASE';
                } else {
                    trafficSourceContent = 'BA_RT_WITHOUT_PURCHASE';
                }
            } else if (this.models.checkoutCart.isBillingPurchase()) {
                if (isRP) {
                    trafficSourceContent = 'BA_RP_WITH_PURCHASE';
                } else {
                    trafficSourceContent = 'BA_RT_WITH_PURCHASE';
                }
            }

            var clientMetadataID = void 0;

            if (window.xprops && window.xprops.clientMetadataID) {
                clientMetadataID = window.xprops.clientMetadataID;
            } else if (_squid.$util.param('client-metadata-id')) {
                clientMetadataID = _squid.$util.param('client-metadata-id');
            } else {
                clientMetadataID = this.props.token;
            }

            var merchantCountry = this.models.checkoutAppData.get('merchant.merchant_country');
            var capeData = {
                'flow_attributes': {
                    'channel': _index.$DeviceInfo.isMobile() ? 'MOBILE' : 'WEB',
                    'flow': flow,
                    'primary_actor': 'PAYPAL',
                    'tracking_id': this.props.token,
                    'business_case_variation': transactionType,
                    'credit_application_traffic_source': trafficSourceContent
                },
                'locale': _squid.$locale.lang + '_' + _squid.$locale.country,
                'cart_id': this.props.token,
                'fraudnet_id': clientMetadataID,
                'context-type': pageContext,
                'cal_correlation_id': _model.$CalDataModel.getCalCorrId(),
                // LU merchant will not be considered cross border for eBay-RM - fix to hide installments unavailable banner in CAPE acq
                'is_cross_border_with_installments': this.creditDataModel.isCrossBorder() && this.creditDataModel.hasSelectedCYCOOffer() && merchantCountry !== 'LU',
                'return_uris': {
                    'normal_return_uri': returnUrl + '&success=true',
                    'system_error_uri': returnUrl + '&success=false&isInternalServiceError=true',
                    'return_to_login_uri': returnUrl,
                    'full_pay_uri': this.models.auth.logged_in ? returnUrl + '&success=false&fullPay=true' : undefined,
                    'cancel_uri': getCancelUrl(this.models.checkoutAppData.urls.cancel_url, this.props.token),
                    'change_installments_uri': returnUrl + '&changeStatus=changeInstallment&creditSignup=' + isSignupFlow
                },
                'installment_count': this.creditDataModel.getInstallmentCount(),
                'show_cyco': _uiRouter.$stateParams && _uiRouter.$stateParams.showCapeCyco,
                'is_reuse': isPPCReuse,
                'financial_instrument_id': isPPCReuse ? fundingSource.id : ''
            };

            if (_uiRouter.$stateParams && _uiRouter.$stateParams.financing_option) {
                capeData.financing_option = _uiRouter.$stateParams.financing_option;
            }

            if (this.$root.MORS) {
                // There are MORS campaigns
                // Check to see if there are any "credit incentive" campaigns
                // which we need to notify CAPE of
                var creditIncentiveCampaign = getMORSCreditIncentiveCampaign(this.$root.MORS);

                if (creditIncentiveCampaign) {
                    capeData.credit_incentive = createCreditIncentiveContextData(creditIncentiveCampaign);
                }
            }

            return (0, _angular.$q)(function (resolve, reject) {
                var secondButtonCrossBorder = _this3.models.checkoutAppData.is_second_button_txn && _this3.creditDataModel.isCrossBorder();
                // To support ChecoutLite fallback, we need to check wehther $CreditDataModel.getCartAmountAndCurrency()
                // has the cart_acmount & cart_currency.
                var isGBCrossCurrency = _this3.buyerCountry === 'GB' && _this3.currencyCode !== 'GBP' && !_this3.creditDataModel.getCartAmountAndCurrency();

                if (!secondButtonCrossBorder && !isGBCrossCurrency) {
                    return resolve();
                }

                // Second Button / Cross Border
                var offers = new _index2.$CreditInstallmentOptionsModel({
                    id: _this3.props.token,
                    payee: _this3.models.checkoutPayee,
                    checkoutCart: _this3.models.checkoutCart,
                    checkoutAppData: _this3.models.checkoutAppData,
                    isMemberCredit: true
                });

                offers.save({
                    cache: false,
                    success: function success(result) {
                        capeData.installment_count = offers.getInstallmentCount();

                        if (result && result.conversion_info && result.conversion_info.converted_transaction_amount) {
                            _logger.$logger.info('redirectToCape: Setting Cross Country cart_amount and cart_currency');
                            _this3.creditDataModel.setCartAmountAndCurrency({
                                cart_amount: result.conversion_info.converted_transaction_amount.value,
                                cart_currency: result.conversion_info.converted_transaction_amount.currency_code
                            });
                        }

                        return resolve();
                    },
                    error: function error(_error) {
                        _logger.$logger.info('redirectToCape: ssot call returned error: ' + _error);
                        return reject(_error);
                    },
                    contingencies: {
                        DEFAULT: function DEFAULT(name, err) {
                            _logger.$logger.info('redirectToCape: ssot call returned contingency: ' + name);
                            return reject(err);
                        }
                    }
                });
            }).then(function () {
                Object.assign(capeData, _this3.creditDataModel.getCartAmountAndCurrency());
                var data = {
                    creditData: capeData,
                    newUserSignup: isSignupFlow
                };

                return _this3.creditDataModel.action('createCreditKey', {
                    data: data,
                    success: function success(res) {
                        var useMerchantCountry = false;

                        // For 2nd button and non-logged-in users -
                        // use the merchant_country as the flow when redirecting to CAPE
                        if (!_this3.models.auth.logged_in && _this3.models.checkoutAppData.is_second_button_txn) {
                            // If merchant country is unsupported, fallback to the buyer country (which in turn falls back to US)
                            if (!merchantCountry || _squid.$config.creditEligibleCountries.indexOf(merchantCountry) === -1) {
                                _logger.$logger.info('CAPE_use_buyer_country=' + _squid.$locale.country + ', for_locale_country=' + _squid.$locale.country + ', for_locale_lang=' + _squid.$locale.lang);
                            } else {
                                useMerchantCountry = true;
                                _logger.$logger.info('CAPE_use_merchant_country=' + merchantCountry + ', for_locale_country=' + _squid.$locale.country + ', for_locale_lang=' + _squid.$locale.lang);
                            }
                        }

                        var capeUrl = (0, _squid.$feature)('capeUrl', undefined, useMerchantCountry && merchantCountry) + res.capeKey + '&token=' + _this3.props.token;

                        if (_this3.creditDataModel.isChangeStatus()) {
                            capeUrl += '&status=changeInstallment';
                        }

                        var sdkMeta = _squid.$util.param('sdkMeta');
                        if (sdkMeta) {
                            capeUrl += '&sdkMeta=' + sdkMeta;
                        }

                        _this3.creditDataModel.setCapeRedirectUri(capeUrl);

                        var purchaseUnits = _this3.models.checkoutCart && _this3.models.checkoutCart.purchaseUnits;
                        var purchaseUnit = _angular2['default'].isArray(purchaseUnits) && purchaseUnits[0];
                        var currency = purchaseUnit && purchaseUnit.amount && purchaseUnit.amount.currency;

                        _logger.$logger.info('CAPE_locale_logging', {
                            brand_name: _this3.models.checkoutAppData.get('merchant.brand_name'),
                            merchant_id: _this3.models.checkoutPayee.getId(),
                            merchant_country: merchantCountry,
                            merchant_locale: _this3.models.checkoutAppData.get('merchant.merchant_locale'),
                            merchant_display_id: _this3.models.checkoutAppData.get('merchant.merchant_display_id'),
                            currency: currency,
                            user_locale: _squid.$locale.getLocaleCode()
                        });

                        _squid.$util.redirect(capeUrl, { replace: true });
                    }
                });
            });
        }
    }
});


_logger.$logger;

_auth.$AuthModel;

_model.$CalDataModel;

_index.$DeviceInfo;

_index2.$CreditDataModel;

_index2.$CreditInstallmentOptionsModel;

_squid.$Class;

_squid.$Component;

_squid.$util;

_squid.$config;

_squid.$locale;

_squid.$feature;

_squid.$integration;

_squid.$elmo;

_index3.$CheckoutAppDataModel;

_index3.$CheckoutCartModel;

_index3.$CheckoutPayeeModel;

_index3.$CheckoutSessionModel;

_uiRouter.$stateParams;

_xoCreditBannerUtils.$xoCreditBannerUtils;

_constants.deContentKeys;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-credit-components/src/redirect-to-cape/directive.js
// module id = ../node_modules/xo-credit-components/src/redirect-to-cape/directive.js
// module chunks = 0